export default "__VITE_ASSET__BG8yY89Z__"